var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCircleCheck = function SvgCircleCheck(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#15803D",
    fillRule: "evenodd",
    d: "M.233 7.001a6.767 6.767 0 1 1 13.534 0 6.767 6.767 0 0 1-13.534 0Zm9.476-.885a.667.667 0 0 0-.752-1.101l-.067.046a10.656 10.656 0 0 0-2.783 2.778l-.97-.968a.667.667 0 1 0-.941.943l1.56 1.56a.667.667 0 0 0 1.05-.141 9.323 9.323 0 0 1 2.836-3.071l.067-.046Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCircleCheck);
export default ForwardRef;